import * as Actions from "../actions";
import * as GeneralActions from "../../general/actions"
import * as Selectors from "../selectors"
import * as GeneralSelectors from "../../general/selectors"
import * as Top from "../../reducers"
type State = Top.State
type Dispatch = (action: (Actions.Action | GeneralActions.Action)) => void

export { Actions, GeneralActions, Selectors, GeneralSelectors, State, Dispatch }